import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

const PickupDate = ({ date }) => {
  const { i18n } = useTranslation()
  const { info } = useContext(AppContext)

  if (!date) return '-'

  const formattedDate = new Intl.DateTimeFormat(i18n.language, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    timeZone: info?.selectedStore?.timezone,
  }).format(new Date(date))

  return (
    <Text type="bodyMRegular" customStyles={{ textTransform: 'uppercase', width: '148px' }}>
      {formattedDate}
    </Text>
  )
}

export default PickupDate
